import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
  DataTableColumnDateProps,
  DataTableServerQuery,
  DataTableRowActions,
} from '@/components/data-table-builder/data-table.types';
import { DacGeneralParamsRepository } from '@/store/dac-general-params-state/dac-general-params-state.repository';
import { ParametrageGeneralDac } from '@/types';

interface getDacGeneralParamsDataTableStructureProps {
  store: DacGeneralParamsRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getDacGeneralParamsDataTableStructure = ({
  store,
  createAction,
  rowActions,
  serverQuery,
}: getDacGeneralParamsDataTableStructureProps): DynamicDataTable => {
  const fieldLabelColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dacGeneralParams.table.fieldLabel',
    accessorKey: 'paramGeneralLabel',
    variant: DataTableColumnVariant.TEXT,
  };

  const dynaDocsModelsColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dacGeneralParams.table.dynaDocsModel',
    accessorKey: 'dynaDocsModels_joined',
    variant: DataTableColumnVariant.TEXT,
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'dacGeneralParams.table.createdAt',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'dacGeneralParams.table.updatedAt',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  return {
    singular: 'dacGeneralParams.singular',
    plural: 'dacGeneralParams.plural',
    columns: [fieldLabelColumn, dynaDocsModelsColumn, createdAtColumn, updatedAtColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    createAction,
    target: (row: ParametrageGeneralDac) => {
      store.setNested('response', row);
      store.setNested('updateDto', {
        dynaDocsModelIds: row.dynaDocsModels?.map(m => m.dynaDocsModel.dynaDocsModelId) || [],
      });
      store.set('dynaDocsModelSelected', row.dynaDocsModels?.map(m => ({
        name: m.dynaDocsModel.description,
        code: m.dynaDocsModel.dynaDocsModelId,
      })) || []);
    },
    rowActions,
    searchableFields: [],
    enableFiltering: true,
    enableServerActions: true,
    serverQuery,
  };
};
